import axios from 'axios'
import { UpdateCorporateResponse, CorporateData } from '../../types/corporate'

export const updateCorporate = async (
  data: CorporateData
): Promise<UpdateCorporateResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const formData = new FormData()
    formData.append('project_id', data.project_id.toString())

    if (data.workload !== undefined) {
      formData.append('workload', data.workload)
    }

    if (data.departments !== undefined) {
      formData.append('departments', JSON.stringify(data.departments))
    }

    if (data.goal !== undefined) {
      formData.append('goal', data.goal)
    }

    if (data.competencies !== undefined) {
      formData.append('competencies', JSON.stringify(data.competencies))
    }

    if (data.expectedBehaviors !== undefined) {
      formData.append('expectedBehaviors', data.expectedBehaviors)
    }

    if (data.indicators !== undefined) {
      formData.append('indicators', JSON.stringify(data.indicators))
    }

    if (data.currentGoal !== undefined) {
      formData.append('currentGoal', data.currentGoal)
    }

    if (data.structure !== undefined) {
      formData.append('structure', JSON.stringify(data.structure))
    }

    if (data.realizeUnitId !== undefined) {
      formData.append('realizeUnitId', data.realizeUnitId)
    }

    if (data.folder_id !== undefined) {
      formData.append(
        'folder_id',
        data.folder_id === null ? '' : data.folder_id.toString()
      )
    }

    const response = await axios.put(
      `${backendUrl}/n8n/mavis/corporate`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return (response.data as unknown) as UpdateCorporateResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
